import type { Section } from "../lib/signApi.js";
import { useAvailabilitySetting } from "../lib/signApi.js";

export const useIsServiceAvailable = (
  section: Section,
): {
  isAvailable: boolean;
  isLoading: boolean;
  message?: string;
  error?: Error;
} => {
  const {
    data: availabilitySetting,
    isLoading,
    error,
  } = useAvailabilitySetting(section);

  if (error) {
    return { isAvailable: false, isLoading: false, error: error as Error };
  }

  if (isLoading || !availabilitySetting) {
    return { isAvailable: false, isLoading };
  }

  const message =
    availabilitySetting.status === "closed"
      ? availabilitySetting.customMessage || undefined
      : undefined;

  return {
    isAvailable: availabilitySetting.isAvailable || false,
    isLoading: false,
    message: message,
  };
};
